import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import clsx from "clsx";
import objectPath from "object-path";

import KTHeader from "_metronic/_assets/js/header";
import * as builder from "_metronic/ducks/builder";
import HMenu from "_metronic/layout/header/HMenu/HMenu";
import TopBar from "_metronic/layout/header/Topbar";

import AnimateLoading from "app/partials/layout/AnimateLoading";

const Header = () => {
  const headerCommonRef = useRef();

  // Redux selectors using useSelector hook
  const headerClasses = useSelector((store) =>
    builder.selectors.getClasses(store, {
      path: "header",
      toString: true,
    })
  );
  const headerAttributes = useSelector((store) =>
    builder.selectors.getAttributes(store, { path: "header" })
  );
  const menuHeaderDisplay = useSelector((store) =>
    objectPath.get(store.builder.layoutConfig, "header.menu.self.display")
  );

  useEffect(() => {
    let options = {};
    if (headerCommonRef.current.getAttribute("data-ktheader-minimize") === "1") {
      options["minimize.desktop.on"] = "kt-header--minimize";
      options["offset.desktop"] = 130;
    }

    // eslint-disable-next-line no-undef
    new KTHeader(headerCommonRef.current, options);
  }, []);

  return (
    <div
      className={clsx("kt-header kt-grid__item", headerClasses)}
      id="kt_header"
      ref={headerCommonRef}
      {...headerAttributes}
    >
      <AnimateLoading />
      {/* <!-- begin: Header Menu --> */}
      {menuHeaderDisplay && <HMenu />}
      {/* <!-- end: Header Menu --> */}
      {/* <!-- begin:: Header Topbar --> */}
      {/* <!-- empty div to fix topbar to stay on the right when menu-horizontal is hidden --> */}
      {!menuHeaderDisplay && <div />}
      <TopBar />
      {/* <!-- end:: Header Topbar --> */}
    </div>
  );
};

export default Header;
